import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";
import {translate} from '@elements/translations';
import {findIn} from '@elements/dom-utils';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init({
    submitOnChange: false,
    addUrlParams: true
});

import * as supplyCalculator from './scripts/supply-calculator';
supplyCalculator.init();